/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { Stack, RadioButton, ButtonGroup, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import history from 'src/routes/history';
import { routes } from 'src/routes';

type Props = {
  handleChangeState: () => void
};

type ComposedProps = Props & WithI18nProps;

class Option3 extends Component<ComposedProps> {
  render() {
    const { i18n } = this.props;
    return (
      <div>
        <Stack vertical>
          <RadioButton
            label={i18n.translate('AdminHTML.ThemeUpgrade.VerifyUpgrade.option3_Label')}
            checked={true}
            id="3"
            name="options"
          />
          <p style={{ marginLeft: '1.75rem' }}>
            {i18n.translate('AdminHTML.ThemeUpgrade.VerifyUpgrade.option3_Content')}
          </p>
          <div style={{ marginLeft: 'auto' }}>
            <ButtonGroup>
              <Button onClick={this.back}>{i18n.translate('AdminHTML.Common.Action.back')}</Button>
              <Button primary onClick={this.toThemeUpgrade}>
                {i18n.translate('AdminHTML.ThemeUpgrade.VerifyUpgrade.option3_ActionGotoUpgrade')}
              </Button>
            </ButtonGroup>
          </div>
        </Stack>

        <span className="clear" />
      </div>
    );
  }

  // Handle back action
  back = () => {
    const { handleChangeState } = this.props;

    handleChangeState(0);
  };

  //Handle go to theme setup action
  toThemeUpgrade = () => {
    history.push(routes.themeUpgrade.view());
  };
}

export default withI18n()(Option3);
